/* unplugin-vue-components disabled */import script from "./CapabilityEditCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CapabilityEditCard.vue?vue&type=script&setup=true&lang=js"

import "./CapabilityEditCard.vue?vue&type=style&index=0&id=78668122&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78668122"]])

export default __exports__